import { HOURS_PER_DAY } from '../../../constants';
import { fmtDate } from '../../../utils/format';
import { phaseNetJiraHours } from '../../../utils/jira';
import { devsByIdMap, phaseSoldDays, timeAndMaterialsCapacity } from '../../../utils/phases';
import { phaseAssignedDays } from '../../../utils/planning';
import { lanesHeight } from '../shared/lanes';

const round1 = (n) => Math.round(n * 10) / 10;
const color = (vendu, pct, normal) =>
  vendu === 0 ? normal : pct > 100 ? '#E24B4A' : pct > 85 ? '#EF9F27' : normal;

/* Métriques d'une phase (en jours) — mêmes routes que l'onglet « Suivi général » : planifié,
   consommé Jira, et vendu (jours vendus d'un forfait, capacité d'une régie). */
export function phaseMetrics(ph, client, appState, jiraData, maintenanceLabelHours) {
  const fact = ph.facturation || 'forfait_brique';
  const plannedDays = round1(
    phaseAssignedDays(appState.affectations, ph, devsByIdMap(appState.devs)),
  );
  // Même « consommé Jira » que la fiche projet (temps de maintenance concomitante retiré).
  const jiraHours = phaseNetJiraHours(
    jiraData,
    appState.clients,
    ph,
    client,
    maintenanceLabelHours || {},
  );
  const jiraDays = round1(jiraHours / HOURS_PER_DAY);
  let vendu = 0;
  if (fact === 'forfait_brique' || fact === 'forfait_global') vendu = phaseSoldDays(ph);
  else if (fact === 'regie_temporelle' || fact === 'regie_horaire')
    vendu = timeAndMaterialsCapacity(ph);
  vendu = round1(vendu);
  const consoPct = vendu > 0 ? (jiraDays / vendu) * 100 : 0;
  const planPct = vendu > 0 ? (plannedDays / vendu) * 100 : 0;
  return {
    plannedDays,
    jiraDays,
    vendu,
    consoPct,
    planPct,
    consoColor: color(vendu, consoPct, '#0C7A8A'),
    planColor: color(vendu, planPct, '#8b5cf6'),
  };
}

export const phaseDatesLabel = (ph) =>
  ph.dateDebut && ph.dateFin
    ? `${fmtDate(ph.dateDebut)} → ${fmtDate(ph.dateFin)}`
    : ph.dateDebut
      ? `dès ${fmtDate(ph.dateDebut)}`
      : null;

// Une phase est visible si sa période chevauche la fenêtre affichée (s'adapte au scroll/nav)
export function phaseInWindow(ph, firstIso, lastIso) {
  const s = ph.dateDebut || null,
    e = ph.dateFin || null;
  if (!s && !e) return true;
  if (e && e < firstIso) return false;
  if (s && s > lastIso) return false;
  return true;
}

// La cellule nom (titre + stats + barre de progression + dates) peut avoir besoin de
// plus de hauteur que la zone des barres (basée sur nLanes) si le projet a peu de
// barres actives mais tout son texte affiché : sans ce plancher, les deux volets
// (colonne de noms / grille des jours), désormais rendus séparément, se désaligneraient.
export function phaseRowHeight(nLanes, vendu, datesTxt) {
  const nameLines = 2 + (vendu > 0 ? 1 : 0) + (datesTxt ? 1 : 0); // titre + stats (+ barre) (+ dates)
  return Math.max(64, lanesHeight(nLanes), 18 + nameLines * 17);
}
